import { DOCUMENT, inject, Injectable, signal } from '@angular/core';
import { GetVersionGQL } from '@features/dashboard/queries/GetVersion.gql';
import { from, switchMap, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IconSpriteService {
    private readonly versionQuery = inject(GetVersionGQL);
    private readonly document = inject<Document>(DOCUMENT);
    private readonly iconsElementId = 'pnyci-icons';
    public readonly sprite = signal<string>('');

    loadIconSprite(): void {
        // from(this.versionQuery.fetch({ context: { requireAuth: false } })).pipe(
        //     tap(({ data }) => console.log(`Loading icon sprite v${data.version}`)),
        // switchMap(({ data: { version } }) =>
        // fetch(`assets/sprites/icons.svg?v=${version}`, { cache: 'no-cache' })
        // ),
        from(fetch(`assets/sprites/icons.svg?v=${new Date().getTime()}`, { cache: 'no-cache' })).pipe(
            switchMap((response) => response.text()),
            tap((icons) => {
                this.sprite.set(icons);
                this.insertIconsElement(icons);
            })
        ).subscribe();
    }

    private insertIconsElement(icons: string): void {
        if (this.document.body === null) {
            this.document.addEventListener('DOMContentLoaded', () => this.injectSprite(icons));
        } else {
            this.injectSprite(icons);
        }
    }

    private injectSprite(icons: string): void {
        const existingSprite = this.document.getElementById(this.iconsElementId);

        if (existingSprite != null) {
            existingSprite.remove();
        }

        const tempContainer = this.document.createElement('div');

        tempContainer.innerHTML = icons;
        const spriteElement = tempContainer.firstElementChild;

        if (spriteElement == null) {
            return;
        }

        spriteElement.id = this.iconsElementId;
        this.document.body.insertAdjacentElement('beforeend', spriteElement);
    }
}
